import { Button, useDisclosure, MenuItem } from '@chakra-ui/react';
import React from 'react';

import {
  FundingRequestEntitiesFragmentGQLType,
  ShareFundingComponentFragmentGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { MarkLenderShareComponentFundedModal } from './MarkLenderShareComponentFundedModal';
import { colors } from '~/packages/common-frontend/colors';

interface MarkLenderShareComponentFundedButtonProps {
  fundingRequest: FundingRequestEntitiesFragmentGQLType;
  fundingComponent: ShareFundingComponentFragmentGQLType;
}

export const MarkLenderShareComponentFundedButton = ({
  fundingRequest,
  fundingComponent,
}: MarkLenderShareComponentFundedButtonProps) => {
  const modalControls = useDisclosure();

  return (
    <>
      <Button
        aria-label="mark funded"
        onClick={modalControls.onOpen}
        variant="secondary"
        color={colors['v2-aurora'][800]}
      >
        Mark Funded
      </Button>
      <MarkLenderShareComponentFundedModal
        fundingComponent={fundingComponent}
        fundingRequest={fundingRequest}
        modalControls={modalControls}
      />
    </>
  );
};

export const MarkLenderShareComponentFundedMenuItem = ({
  fundingRequest,
  fundingComponent,
}: MarkLenderShareComponentFundedButtonProps) => {
  const modalControls = useDisclosure();

  const buttonText = fundingComponent.fundTransferDate
    ? 'Change Lender Funded Date'
    : 'Mark Funded';

  return (
    <MenuItem as="div">
      <Button
        variant="unstyled"
        fontWeight={400}
        color={colors.gray[800]}
        onClick={modalControls.onOpen}
      >
        {buttonText}
      </Button>
      <MarkLenderShareComponentFundedModal
        fundingComponent={fundingComponent}
        fundingRequest={fundingRequest}
        modalControls={modalControls}
      />
    </MenuItem>
  );
};
